export const loadingSpinnerTime = 200;
export const loadingSpinnerSize = 100;
